import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/menuCategoryEntity";
import { setFlashSuccess, setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchMenuCategories = createAsyncThunk(
	"datasources/menuCategories/fetchMenuCategories",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/menu-categories/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.menuCategories);
			
			return { 
				...normalized, 
				pagination: response.data.pagination || {} 
			};
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu category could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const fetchMenuCategory = createAsyncThunk(
	"datasources/menuCategories/fetchMenuCategory",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/menu-categories/view", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.menuCategory);
			
			return normalized;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu category could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const saveMenuCategory = createAsyncThunk(
	"datasources/menuCategories/saveMenuCategory",
	async (request, thunkAPI) => {
		try {
			const formData = { ...request };
			const action = formData.id ? "edit" : "add";
			const response = await fsrHttpInstance.then(fsrService => fsrService.post(`vendor/menu-categories/${action}`, formData, fsrHttpConfiguration()));

			thunkAPI.dispatch(setFlashSuccess("The menu category has been saved."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu category could not be saved. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const deleteMenuCategory = createAsyncThunk(
	"datasources/menuCategories/deleteMenuCategory",
	async (request, thunkAPI) => {
		try {
			const params = request.query ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.post("vendor/menu-categories/delete", null, {...params, ...fsrHttpConfiguration()}));

			thunkAPI.dispatch(setFlashSuccess("The menu category has been deleted."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu category could not be deleted. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);